<submission-details-table></submission-details-table>


<pandora-aside #submInfoAside
      [title]="'Submission Info'"
      [isAsideOpen]=true
      [closeText]="'Close'"
      [closeChevron]=false
      [isToggleAvailable]=false
      [isToggleButtonExists]=false>
    <div aside-content><submInfo-Sidebar #submInfoSidebarComponent></submInfo-Sidebar></div>
</pandora-aside>
